const MAX_BODY_LENGTH = 65_536;
const MAX_JSON_LAYERS = 3;
const projectMutationConflictMessage = 'Операция конфликтует с другим изменением проекта. Обновите данные и повторите действие.';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function read(value: unknown, key: string): unknown {
  try {
    if (!isRecord(value)) return undefined;
    return value[key];
  } catch {
    return undefined;
  }
}

function decodeBody(body: unknown): unknown {
  let value = body;
  if (value instanceof ArrayBuffer) {
    if (value.byteLength > MAX_BODY_LENGTH) return undefined;
    value = new TextDecoder().decode(value);
  }
  for (let layer = 0; layer < MAX_JSON_LAYERS && typeof value === 'string'; layer++) {
    if (value.length > MAX_BODY_LENGTH) return undefined;
    const text = value.trim();
    if (!text) return undefined;
    if (!/^["\[{]/.test(text)) return text;
    try {
      value = JSON.parse(text);
    } catch {
      return text;
    }
  }
  return typeof value === 'string' && value.length > MAX_BODY_LENGTH ? undefined : value;
}

function responseOf(error: unknown): unknown {
  return read(error, 'response');
}

function statusOf(error: unknown): number | undefined {
  const status = read(responseOf(error), 'status');
  return typeof status === 'number' && Number.isInteger(status) && status >= 100 && status < 600
    ? status : undefined;
}

function errorBody(error: unknown): unknown {
  const response = responseOf(error);
  return response === undefined || response === null ? error : read(response, 'data');
}

export function getProjectMutationConflictMessage(error: unknown, body: unknown = errorBody(error)): string | undefined {
  return statusOf(error) === 409 && read(decodeBody(body), 'Code') === 'ProjectMutationConflict'
    ? projectMutationConflictMessage : undefined;
}
